(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rewards-membership-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-global-rewards-dialog]');
    const openButton = document.querySelector('[data-global-rewards-open]');
    const closeButton = document.querySelector('[data-global-rewards-close]');
    if (!dialog || !openButton) return;
    const open = () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      dialog.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
    };
    openButton.addEventListener('click', open);
    closeButton?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    if (dialog.querySelector('[data-global-rewards-success]')) open();
  })();
  } catch(e) { console.error(e); }
})();

})();
